$(function () {

  $.fn.serializeObject = jQuery.fn.serializeObject = function() {
    var o = {};
    var a = this.serializeArray();
    $.each(a, function() {
     if (o[this.name] !== undefined) {
       if (!o[this.name].push) {
         o[this.name] = [o[this.name]];
       }
       o[this.name].push(this.value || '');
     } else {
       o[this.name] = this.value || '';
     }
    });
    return o;
  };

  var northAmericanStates = {
    "AL": "Alabama",
    "AK": "Alaska",
    "AS": "American Samoa",
    "AZ": "Arizona",
    "AR": "Arkansas",
    "CA": "California",
    "CO": "Colorado",
    "CT": "Connecticut",
    "DE": "Delaware",
    "DC": "District Of Columbia",
    "FM": "Federated States Of Micronesia",
    "FL": "Florida",
    "GA": "Georgia",
    "GU": "Guam",
    "HI": "Hawaii",
    "ID": "Idaho",
    "IL": "Illinois",
    "IN": "Indiana",
    "IA": "Iowa",
    "KS": "Kansas",
    "KY": "Kentucky",
    "LA": "Louisiana",
    "ME": "Maine",
    "MH": "Marshall Islands",
    "MD": "Maryland",
    "MA": "Massachusetts",
    "MI": "Michigan",
    "MN": "Minnesota",
    "MS": "Mississippi",
    "MO": "Missouri",
    "MT": "Montana",
    "NE": "Nebraska",
    "NV": "Nevada",
    "NH": "New Hampshire",
    "NJ": "New Jersey",
    "NM": "New Mexico",
    "NY": "New York",
    "NC": "North Carolina",
    "ND": "North Dakota",
    "MP": "Northern Mariana Islands",
    "OH": "Ohio",
    "OK": "Oklahoma",
    "OR": "Oregon",
    "PW": "Palau",
    "PA": "Pennsylvania",
    "PR": "Puerto Rico",
    "RI": "Rhode Island",
    "SC": "South Carolina",
    "SD": "South Dakota",
    "TN": "Tennessee",
    "TX": "Texas",
    "UT": "Utah",
    "VT": "Vermont",
    "VI": "Virgin Islands",
    "VA": "Virginia",
    "WA": "Washington",
    "WV": "West Virginia",
    "WI": "Wisconsin",
    "WY": "Wyoming",
    "BC": "British Columbia",
    "ON": "Ontario",
    "NL": "Newfoundland and Labrador",
    "NS": "Nova Scotia",
    "PE": "Prince Edward Island",
    "NB": "New Brunswick",
    "QC": "Quebec",
    "MB": "Manitoba",
    "SK": "Saskatchewan",
    "AB": "Alberta",
    "NT": "Northwest Territories",
    "NU": "Nunavut",
    "YT": "Yukon Territory",
    "DIF": "Distrito Federal",
    "AGU": "Aguascalientes",
    "BCN": "Baja California",
    "BCS": "Baja California Sur",
    "CAM": "Campeche",
    "COA": "Coahuila",
    "COL": "Colima",
    "CHP": "Chiapas",
    "CHH": "Chihuahua",
    "DUR": "Durango",
    "GUA": "Guanajuato",
    "GRO": "Guerrero",
    "HID": "Hidalgo",
    "JAL": "Jalisco",
    "MEX": "México",
    "MIC": "Michoacán",
    "MOR": "Morelos",
    "NAY": "Nayarit",
    "NLE": "Nuevo León",
    "OAX": "Oaxaca",
    "PUE": "Puebla",
    "QUE": "Querétaro",
    "ROO": "Quintana Roo",
    "SLP": "San Luis Potosí",
    "SIN": "Sinaloa",
    "SON": "Sonora",
    "TAB": "Tabasco",
    "TAM": "Tamaulipas",
    "TLA": "Tlaxcala",
    "VER": "Veracruz",
    "YUC": "Yucatán",
    "ZAC": "Zacatecas"
  };

    var newRedirect = '/connect/';
    var resultsPageCurrent = 1;



    var init = function init () {

      // $('.autocomplete').autocomplete({
      //   source: window.specialities,
      //   change: function (event, ui) {
      //     var element = event.currentTarget.id;

      //     if (ui.item == null || ui.item == undefined) {
      //       var txtSearchProNum = $("#" + element);
      //       txtSearchProNum.val("");
      //     }
      //   }
      // });


      var queryStringLocation = _getUrlParams('location');
      var queryStringSpecialty = _getUrlParams('specialty');

      if (queryStringLocation || queryStringSpecialty) {

        if (queryStringLocation) {
          setTimeout(function () {
            $('input[data-select="select-mentor-search-current-state"]').prop('checked', true);
            $('input[type="radio"][name="search-type"]').trigger('change');
            $('#mentor-search-current-state').val(queryStringLocation);
            _onSearchFormChange();

          }, 10);

          setTimeout(function () {
            $('form[data-type="state"]').trigger('submit');

          }, 20);
        }

        if (queryStringSpecialty) {
          setTimeout(function () {
            $('input[data-select="select-mentor-search-specialty"]').prop('checked', true);
            $('input[type="radio"][name="search-type"]').trigger('change');
            $('#mentor-search-specialty').val(queryStringSpecialty);
            _onSearchFormChange();

          }, 10);

          setTimeout(function () {
            $('form[data-type="specialty"]').trigger('submit');

          }, 20);
        }

      }

      _addListeners();

      $('input[data-select="select-mentor-search-current-state"]').prop('checked', true);
      $('input[data-select="select-mentor-search-current-state"]').trigger('change');

    }



    var _addListeners = function _addListeners () {


      $('input[type="radio"][name="search-type"]').on('change', _onSearchFormSelection);
      $('input[type="radio"][name="search-type"]').on('change', _onSearchFormChange);


      $('.connect--search-form').on('submit', _onSearchFormSubmit);
      $('.connect--results').on('submit', '.connect--message-form', _messageMentorSubmit);
      $('.connect--results').on('keyup', '.connect--message', _messageMentorCount);
      $('.mentor-profile').on('change', _onSearchFormChange);

      // $('.page-global-health-activities').on('keyup', '.interest-statement', _messagePhysicianActivity);

      $('.connect--mentorship-suggestion-form').on('submit', _onSuggestionFormSubmit);
      $('#mentoship-suggestion-textarea').on('keyup', _onSuggestionChange);

      $('.connect--results').on('click', '.connect--search-btn-pagination', function (event) {
        resultsPageCurrent = Number($(this).attr('data-next-page'));

        $('.select-mentor-search.active').closest('.connect--search-form').trigger('submit');
      });

      $('.connect--results').on('click', '.cancel-message-mentor', function (e) {

        e.preventDefault();
        var messageFormParent = $(this).parent().parent().parent().parent().parent().parent().parent();
        messageFormParent.toggleClass('show-connect--message-form');
        $(this).closest('form').find('textarea').val('');

        $('html,body').animate({
          scrollTop: messageFormParent.offset().top
        }, 'slow');

      });

      $('.navbar-connect-login').on('click', function (e) {
        e.preventDefault();
        $('body').addClass('show-connect--login-form');
      });

      $('.connect--login-form-close').on('click', function (e) {
        e.preventDefault();
        $('body').removeClass('show-connect--login-form');
      });

      $('.connect--results').on('click', '.connect--results-alumni-details-message', function (e) {

        e.preventDefault();

        var pageEl = $('body');

        if (pageEl.hasClass('logged-in')) {

          $('.connect--message-results h4').remove();
          var messageFormParent = $(this).parent().parent().parent();
          var messageForm = messageFormParent.find('.connect--message');

          messageFormParent.toggleClass('show-connect--message-form');

          $('html,body').animate({
            scrollTop: messageForm.offset().top
          }, 'slow');

        } else {

          pageEl.toggleClass('show-connect--login-form');

        }

      });

      $('.connect').on('click', '.connect--results-alumni-content-residency-filter ul li a', function (event) {
        event.preventDefault();
        var filterID = $(this).parent().attr('id');
        var filter_by = $(event.target).attr('data-filter-option');
        $('.connect--search-form input[name="filter_by"]').val(filter_by);

        // submit search form
        var $form = $('.select-mentor-search.active').closest('.connect--search-form');

        $form.trigger('submit');

      });

    }

    var _messageMentorCount = function () {


      var charLength = $(this).val().length;
      $(this).next().find('span').text((250 - charLength));

    }

    var _messageMentorSubmit = function (event) {

      event.preventDefault();

      var thisForm = $(this);
      var formData = thisForm.serializeObject();
      var ajaxData = {
        action: formData.action,
        data: formData
      };

      $.ajax({
        type: "POST",
        url: localized_object.ajax_url,
        data: ajaxData,
        dataType: "json",
        timeout: 20000,
        beforeSend: function () {
          thisForm.find('textarea').prop('disabled', 'disabled');
          thisForm.find('.cancel-message-mentor').prop('disabled', 'disabled');
          thisForm.find('.submit-message-mentor').prop('disabled', 'disabled');
        }
      })
        .done(function (response) {

          var parentEl = thisForm.parent().parent().parent();

          if (typeof response.status !== undefined) {

            parentEl.find('.connect--message-results').html(response.results);

            if (response.status == 'success') {

              parentEl.removeClass('show-connect--message-form');
              thisForm.find('textarea').val('');

              $('html,body').animate({
                scrollTop: parentEl.offset().top
              }, 'slow');

            }

          } else {

            parentEl.find('.connect--message-results').html('<h4 class="error">Something went wrong sending message. Try again later.</h4>');

          }

        })
        .fail(function (request, status, err) {

          console.log('REQUEST => ' + request);
          console.log('STATUS => ' + status);
          console.log('ERR => ');
          console.log(err);

        }).always(function () {
          thisForm.find('textarea').removeProp('disabled');
          thisForm.find('.cancel-message-mentor').removeProp('disabled');
          thisForm.find('.submit-message-mentor').removeProp('disabled');
        });
    }

    //----------------------------------------------------------------------
    // Form Validation
    //----------------------------------------------------------------------
    var _formValidation = function (formData) {

      var validated = false;
      var messaging = '<p>Select either specialty or location</p>';
      var specialty = formData.specialty;
      var location = formData.location;
      var messagingEl = $('.connect--search-messaging');

      if (specialty || location) {
        validated = true;
      }

      if (validated) {
        messagingEl.html('');
      } else {
        messagingEl.html(messaging);
      }

      return validated;

    }

    //----------------------------------------------------------------------
    // Form Event Handlers
    //----------------------------------------------------------------------

    var _onSearchFormSelection = function _onSearchFormSelection (event) {

      event.preventDefault();

      console.log($(this).attr('data-select'));

      $('.select-mentor-search').removeClass('active');
      $('.' + $(this).attr('data-select')).addClass('active');

      $('.connect--search-form-selection').find('label').removeClass('active');
      $(this).parent().addClass('active');
    }


    var _onSearchFormChange = function _onSearchFormChange (event) {

      console.log('dude 2');

      var val = $('.select-mentor-search.active').find('.mentor-profile').val();

      if (val.length > 0) {
        $('.connect--search-form').find('.button').attr('disabled', false);
      } else {
        $('.connect--search-form').find('.button').attr('disabled', true);
      }

      if ($('.select-mentor-search.active').hasClass('select-mentor-search-current-state')) {
        $('.connect--results-alumni-content-residency-filter').show();
      } else {
        $('.connect--results-alumni-content-residency-filter').hide();
      }

      $('.connect--results').empty();
      $('.connect--results-count').empty();

    }

    var _onSearchFormSubmit = function (event) {

      var thisForm;
      var formData;

      event.stopImmediatePropagation();

      if (typeof event !== undefined && event) {

        event.preventDefault();
        thisForm = $(this);
        formData = thisForm.serializeObject();

      }

      if (!_formValidation(formData)) { return };

      // Hide banner
      $('.connect--banner').animate({ 'opacity': 0, 'height': 0 }, function (event) {
        $(this).remove();
      });

      var redirect = $('#login-form').find("input[name='redirect_to']");
      newRedirect = '/connect/';
      var newQueryString = '';

      if (formData.location) {
        newQueryString += '?location=' + formData.location;
      }

      if (formData.specialty) {
        newQueryString += newQueryString ? '&specialty=' + formData.specialty : '?specialty=' + formData.specialty;
      }

      newRedirect += encodeURI(newQueryString);
      redirect.val(newRedirect);

      formData.paged = resultsPageCurrent;

      var action = 'search_mentorship';

      if (formData.filter_by && formData.filter_by != 'all') {
        action = action + '_' + formData.filter_by;
      }

      var ajaxData = {
        action: action,
        wp_nonce: localized_object.nonce,
        data: formData
      };

      $.ajax({
        type: "POST",
        url: localized_object.ajax_url,
        data: ajaxData,
        dataType: "json",
        timeout: 20000,
        beforeSend: function () {
          $('.connect--results').removeClass('show-results');
        }
      })
        .done(function (response) {

          console.log(response);

          $('.connect--results').empty();

          if (response !== null && response.status !== null && response.status !== undefined) {

            if (response.status == 'success') {

              var searchedSpeciality = formData.specialty ? '"' + formData.specialty + '"' : '';
              var searchedLocation = formData.location ? '"' + formData.location + '"' : '';

              if (searchedLocation.length == 2) {
                searchedLocation = northAmericanStates[searchedLocation];
              }

              _updateResults(response, { 'searched_location': searchedLocation, 'searched_speciality': searchedSpeciality });

            } else {

              var query = formData.specialty ? '<strong>' + formData.specialty + '</strong>' : '';
              query += query ? ' and <strong>' + formData.location + '</strong>' : '<strong>' + formData.location + '</strong>';

              $('.connect--results-count').html('<h4>0 results match your search</h4>');
              // Don't shoe empty container if no results
              $('.connect--results ').append(response.results);
            }

            $('html,body').animate({
              scrollTop: $('.connect--results-count').offset().top
            }, 'slow', function () {
              $('.connect--results').addClass('show-results');
            });

          }

        })
        .fail(function (request, status, err) {

          console.log('REQUEST => ' + request);
          console.log('STATUS => ' + status);
          console.log('ERR => ');
          console.log(err);
          console.log('');

        }).always(function () {
          // $('.privacy-radio-input').prop("disabled", false);
        });

    };

    var _onSuggestionChange = function _onSuggestionChange (event) {

      if ($(this).val().length > 0) {
        $(this).parent().parent().find('.button').attr('disabled', false);
      } else {
        $(this).parent().parent().find('.button').attr('disabled', true);
      }

    }

    var _onSuggestionFormSubmit = function _onSuggestionFormSubmit (event) {
      event.preventDefault();

      var thisForm = $(this);
      var formData = thisForm.serializeObject();
      var ajaxData = {
        action: 'submit_mentorship_suggestion',
        wp_nonce: localized_object.nonce,
        data: formData
      };

      $.ajax({
        type: "POST",
        url: localized_object.ajax_url,
        data: ajaxData,
        dataType: "json",
        timeout: 20000,
        beforeSend: function () {

        }
      })
        .done(function (response) {

          if (response.status === 'success') {
            $('.connect--mentorship-suggestion').html(response.results);
          } else {
            $('.connect--mentorship-suggestion').html('<h4 class="error">Something went wrong sending your message. Please Try again later.</h4>');
          }

        })
        .fail(function (request, status, err) {

          console.log('REQUEST => ' + request);
          console.log('STATUS => ' + status);
          console.log('ERR => ');
          console.log(err);

        }).always(function () {

        });
    }


    //----------------------------------------------------------------------
    // UI
    //----------------------------------------------------------------------
    var _updateResults = function _updateResults (response, search) {

      var results = response.results;
      var resultsEl = $('.connect--results');
      var resultsCount = $('.connect--results-count');
      var searchType = $('.connect--search-form-selection').find('label.active input').attr('value');

      resultsCount.removeClass('search-type-specialty').removeClass('search-type-location');
      resultsCount.addClass('search-type-' + searchType.toLowerCase());

      resultsEl.empty();
      resultsCount.empty();

      // var resultsText = (results.length > 1) ? 'results match' : 'result matches';
      // resultsCount.html( '<h4>' + response.totalResults + ' ' + resultsText + ' your search for ' + search.searched_speciality + '' + search.searched_location + '</h4>' );
      var resultsText = 'Results';
      resultsCount.html('<h4>' + resultsText + ' for your search of ' + search.searched_speciality + '' + search.searched_location + '</h4>');

      var filter_link_options = {
        some_variable: 'example'
      };

      var filter_links = _injectProperties($('#alumni-residency-template-filtering-options').html(), filter_link_options);

      resultsCount.append(filter_links);

      if (results.length > 0) {

        for (i = 0; i < results.length; i++) {

          var residencies = results[i].residencies;
          var residencies_result = '';

          for (r = 0; r < residencies.length; r++) {
            residencies_result += _injectProperties($('#alumni-residency-template').html(), residencies[r]);
          }

          results[i]['residencies'] = residencies_result;

          if (_getKeyByValue(results[i]['current_state'], northAmericanStates)) {
            results[i]['current_state'] = _getKeyByValue(results[i]['current_state'], northAmericanStates);
          }

          var result = _injectProperties($('#alumni-template').html(), results[i]);
          var $listing = resultsEl.append(result).find('.result-listing');

        }

      }

      var currentPage = Number(response.currentPage);
      var totalPages = Number(response.totalPages);

      if (totalPages > 1) {

        if (currentPage > 1) {
          var nextpage = currentPage - 1;
          var btn = '<button style="float:left" class="connect--search-btn-pagination connect--search-btn-pagination-previous button button-blue button-account" data-next-page="' + nextpage + '">previous results</button>';
          resultsEl.append(btn);
        }

        if (currentPage < totalPages) {
          var nextpage = currentPage + 1;
          var btn = '<button style="float: right;" class="connect--search-btn-pagination connect--search-btn-pagination-next button button-blue button-account" data-next-page="' + nextpage + '">more results</button>';
          resultsEl.append(btn);
        }

        var status = '<div style="margin: 0 auto; text-align: center; padding-top: 10px">page ' + currentPage + ' of ' + totalPages + '</div>';
        resultsEl.append(status);

      }

    }

    //----------------------------------------------------------------------
    // Util
    //----------------------------------------------------------------------
    var _getUrlParams = function (name, url) {
      if (!url) url = window.location.href;

      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);

      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    var _injectProperties = function _injectProperties (templateHTML, context) {

      var _markup = templateHTML;

      for (var property in context) {
        var propertyString = '{' + property + '}';
        var targetProperty = context[property];

        if (_markup.search(propertyString) != -1) {
          _markup = _markup.replace(new RegExp(propertyString, 'gi'), targetProperty);
        }
      }

      // Remove Unused Tokens
      _markup = _markup.replace(/\{([^}]+)\}/g, "");

      return _markup;

    }

    var _getKeyByValue = function _getKeyByValue (val, obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          if (obj[prop] === val)
            return prop;
        }
      }
    }

    init();

});
